module.exports = __webpack_public_path__ + "static/media/albird.aab060a4.svg";